module.exports = __webpack_public_path__ + "img/1448328019.f314a27f.jpg";